import React, { PureComponent } from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import {
  Input
} from 'semantic-ui-react';
import * as classes from './classes.module.scss';

export default class Search extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { query: '' };
    this.debouncedSetQuery = debounce(this.debouncedSetQuery, 400);
  }

  debouncedSetQuery = () => {
    const { query } = this.state;
    const { onChange } = this.props;
    onChange(query);
  }

  onChange = (e) => {
    this.setState({ query: e.target.value });
    this.debouncedSetQuery();
  }

  render() {
    const { query } = this.state;
    return (
      <Input className={ classes.search } size="small" icon="search" value={ query } placeholder="Search..." onChange={ this.onChange } />
    );
  }
}
